var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgExternal = function SvgExternal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124 8v36c0 2.211-1.789 4-4 4s-4-1.789-4-4V17.656L58.828 74.828C58.047 75.609 57.023 76 56 76s-2.047-.391-2.828-1.172a3.997 3.997 0 0 1 0-5.656L110.344 12H84c-2.211 0-4-1.789-4-4s1.789-4 4-4h36c2.211 0 4 1.789 4 4zm-16 104V64c0-2.211-1.789-4-4-4s-4 1.789-4 4v48c0 2.207-1.793 4-4 4H16c-2.207 0-4-1.793-4-4V32c0-2.207 1.793-4 4-4h48c2.211 0 4-1.789 4-4s-1.789-4-4-4H16C9.383 20 4 25.383 4 32v80c0 6.617 5.383 12 12 12h80c6.617 0 12-5.383 12-12z"
  })));
};

export default SvgExternal;